"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BOOKING_TIMES_FAILURE = exports.BOOKING_TIMES_SUCCESS = exports.BOOKING_TIMES_REQUEST = undefined;
exports.loadBookingTimes = loadBookingTimes;
exports.serviceTimesSuccess = serviceTimesSuccess;

var _api = require("../middleware/api");

var _calendarUtil = require("../calendarUtil");

var _calendarUtil2 = _interopRequireDefault(_calendarUtil);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var BOOKING_TIMES_REQUEST = exports.BOOKING_TIMES_REQUEST = "BOOKING_TIMES_REQUEST";
var BOOKING_TIMES_SUCCESS = exports.BOOKING_TIMES_SUCCESS = "BOOKING_TIMES_SUCCESS";
var BOOKING_TIMES_FAILURE = exports.BOOKING_TIMES_FAILURE = "BOOKING_TIMES_FAILURE";

function loadBookingTimes(serviceIds, garageId) {
  return function (dispatch) {
    var currentTime = new Date();
    currentTime.setHours(0);
    serviceIds = serviceIds.filter(function (id) {
      return id.startsWith("p");
    }).map(function (id) {
      return parseInt(id.replace("p", ""));
    });
    return dispatch(_defineProperty({}, _api.CALL_API, {
      types: [BOOKING_TIMES_REQUEST, BOOKING_TIMES_SUCCESS, BOOKING_TIMES_FAILURE],
      endpoint: "/apps/hpmodule/serviceBooking/times",
      method: "POST",
      authenticated: true,
      body: {
        StartDate: parseInt(currentTime.getTime() / 1000),
        EndDate: parseInt(_calendarUtil2.default.addMonth(currentTime, 4).getTime() / 1000),
        ServiceIds: serviceIds,
        GarageId: garageId,
        TimeWindowDeltaStart: 0,
        DeliverSuggestions: true
      }
    }));
  };
}

function serviceTimesSuccess(availableTimes, suggestedTimes) {
  return {
    type: BOOKING_TIMES_SUCCESS,
    availableTimes: availableTimes,
    suggestedTimes: suggestedTimes
  };
}